import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseButton from '@/components/common/BaseButton.vue'

export interface Props {
  text: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TinyButton',
  props: {
    text: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseButton, {
    class: "tiny-button",
    text: __props.text,
    "is-disabled": false,
    "is-loading": false
  }, null, 8, ["text"]))
}
}

})